import { useEditor } from '../store/editor'
import { normalizeProject } from './model'
import { saveProject } from './api'
import { player } from '../engine/player'

const LS_KEY = 'vaideo-editor:v2:autosave'

export function setUrlProject(id: string | null) {
  const u = new URL(window.location.href)
  if (id) u.searchParams.set('project', id)
  else u.searchParams.delete('project')
  u.searchParams.delete('vaideoImport')
  window.history.replaceState({}, '', u.toString())
}

export function writeLocal() {
  const s = useEditor.getState()
  try {
    localStorage.setItem(LS_KEY, JSON.stringify({ serverId: s.serverId, project: s.project }))
  } catch { /* quota / private mode: server save still covers it */ }
}

export function readLocal(): { serverId: string | null; project: ReturnType<typeof normalizeProject> } | null {
  try {
    const raw = localStorage.getItem(LS_KEY)
    if (!raw) return null
    const v = JSON.parse(raw)
    if (!v?.project) return null
    return { serverId: v.serverId ?? null, project: normalizeProject(v.project) }
  } catch {
    return null
  }
}

export function clearLocal() {
  try { localStorage.removeItem(LS_KEY) } catch { /* ignore */ }
}

let inflight: Promise<boolean> | null = null

/** Save to the user's account. Returns true on success. */
export async function saveNow(opts: { silent?: boolean } = {}): Promise<boolean> {
  const s = useEditor.getState()
  if (!s.user) {
    if (!opts.silent) s.toast('Inicia sesión para guardar en tu cuenta. De momento se guarda en este navegador.')
    return false
  }
  if (inflight) return inflight
  inflight = (async () => {
    const st = useEditor.getState()
    const snapshotOf = st.project
    st.set({ saving: true })
    try {
      const thumb = player.snapshot(320) ?? undefined
      const r = await saveProject({
        id: st.serverId ?? undefined,
        name: snapshotOf.name.trim() || 'Proyecto sin título',
        data: snapshotOf,
        thumbnailDataUrl: thumb,
      })
      const now = useEditor.getState()
      now.set({
        serverId: r.id,
        savedAt: Date.now(),
        saving: false,
        dirty: now.project !== snapshotOf ? true : false,
      })
      setUrlProject(r.id)
      writeLocal()
      if (!opts.silent) now.toast('Proyecto guardado', 'ok')
      return true
    } catch (e) {
      useEditor.getState().set({ saving: false })
      if (!opts.silent) useEditor.getState().toast(`No se pudo guardar: ${(e as Error).message}`, 'error')
      return false
    } finally {
      inflight = null
    }
  })()
  return inflight
}
